import baseApiHelper from "app/redux/baseApiHelper";
import axios from "axios";
import Pusher from "pusher-js";
import React, { useContext, useEffect, useRef, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { getBaseUrl, getPusherConf } from "redux/utils";
const PusherContext = React.createContext();

const usePusherContext = () => {
  return useContext(PusherContext);
}

const PusherWrapper = ({ children }) => {
  const pusherRef = useRef();
  const encounterID = window.location.href.split('/provider-note/')[1] || window.location.search.split('&id=')[1];
  const pusherConf = getPusherConf();
  let pusherKey = pusherConf?.key;
  let pusherCluster = pusherConf?.cluster;
  
  const pusher = new Pusher(pusherKey, {
    cluster: pusherCluster,
  });

  // const pusher = new Pusher(process.env.REACT_APP_PUSHER_ENV_KEY, {
  //   cluster: process.env.REACT_APP_PUSHER_ENV_CLUSTER,
  // });

  const [pusherData, setPusherData] = useState(null);
  const [telemedPusherData, setTelemedPusherData] = useState(null);
  const [esyncPusherData, setEsyncPusherData] = useState(null);
  const [pusherUDS, setPusherUDS] = useState(null);
  const [eSyncAppt, setESyncAppt] = useState(null); // <<-- eSync Appt Related: Do not remove
  const { user } = useSelector(
    ({ auth }) => ({
      user: auth.user
    }),
    shallowEqual
  );
  const { selectedNote } = useSelector(
    ({ providerNote }) => ({
      selectedNote: providerNote.selectedNote,
    }),
    shallowEqual
  );
  const { authToken } = useSelector(
    ({ auth }) => ({
      authToken: auth.authToken
    }),
    shallowEqual
  );


  // const getFailedPusherByHash = async (pusherHash) => {
  //   console.warn("Fetching failed pusher by hash #", pusherHash);
  //   let api_url = getBaseUrl();
  //   let response = await axios.get(
  //     `${api_url}/utilities/get_failed_pusher.json`,
  //     { params: { uuid: pusherHash, e10x: "1" } }
  //   );
  //   if (response?.data?.response?.code == 0) {
  //     let responseData = response?.data?.response?.data;
  //     if (responseData?.json_data?.note_data) {
  //       let note_data = responseData?.json_data?.note_data;
  //       // if (note_data && note_data?.other_data && note_data?.other_data?.encounter_id == encounterID) {
  //       //   console.warn(":::::::::: SETTING NOTE_DATA ::::::::::");
  //       //   setPusherData(note_data);
  //       // }
  //     }
  //   } else {
  //     console.error("Failed to get Failed Pusher Data:", response);
  //   }
  // }

  useEffect(() => {
    if (user && selectedNote) {
      try {
        let channel = null;
        if (!pusherRef.current) {
          channel = pusher.subscribe(user?.uuid);
          channel.bind("my_event", function (data) {
            if (window?.location?.href?.indexOf('local') > -1 || window?.showPusher) {
              // prevent pusher consoles at live, to free the browser
              console.warn(":PUSHER RECEIVED E10x ::", data);
            }
            if (data?.type == 'user_logged_out' && data?.token == authToken) {
              toast.warn('Your session has expired, you will be redirected to Login..');
              setTimeout(() => {
                window.location = '/logout';
              }, 5000);
            } else if (data?.msgtype == 'close_epcs_iframe') {     
              if (data?.otherData?.encounter_id == selectedNote?.encounter_data?.encounter) {
                baseApiHelper().invalidateTags(['Medication',"ProviderNote"]);
              }
            }
            else if (data?.msgtype == "clinical_guidelines_updated") {
              baseApiHelper().invalidateTags(["UDS"]);
              setPusherUDS(data);
            }
            else if (data?.msgtype == "telemed_call_ended" || data?.msgtype == "telemed_call_finished" || data?.msgtype == "telemed_call_joined" || data?.msgtype == "telemed_call_on_hold" || data?.msgtype == "telemed_call_started" || data?.msgtype == "telemed_call_left" || data?.msgtype == "telemed_visitor_added_data" || data?.msgtype == "telemed_user_added_to_room" || data?.msgtype == "telemed_call_checked_in" || data?.msgtype == "telemed_call_checked_out" || data?.msgtype == "telemed_call_cancelled") {
              setTelemedPusherData(data);
              baseApiHelper().invalidateTags(["vezoSessionsListing", "vezoSessionsWaitingList"]);
            }
            else if (data?.msgtype == "esync_note_progress") {
              setEsyncPusherData(data);
            }
          });
        }
        if (channel) {
          pusherRef.current = channel;
        }
      } catch (error) {
        console.log(error)
      }

    }
  }, [user,selectedNote]);

  const defaultValues = {
    pusher,
    pusherData,
    setPusherData,
    telemedPusherData,
    setTelemedPusherData,
    esyncPusherData,
    setEsyncPusherData,
    pusherUDS,
    eSyncAppt,
    setESyncAppt,
  };

  return (
    <PusherContext.Provider value={defaultValues}>
      {children}
    </PusherContext.Provider>
  );
}


export { PusherWrapper as default, usePusherContext, PusherContext};